import FasterRequest from '../network/FasterRequest';

class GetGeoLocationRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_GET;

  public headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  public endpoint(): string {
    return 'v1/geoip';
  }

  public query = (): string => '';
}

export default GetGeoLocationRequest;
